import styled from 'styled-components';
import { media } from '../../styles/media';

export const Root = styled.ul`
  align-items: baseline;

  flex-direction: row;
  margin-top: ${props => props.theme.layout.gutter}px;
  display: none;

  ${media.tablet`
    display: flex;
  `};
`;

export const Item = styled.li`
  font-family: ${props => props.theme.font.body.fontFamily};
  font-size: ${props => props.theme.font.body.fontSize};
  line-height: ${props => props.theme.font.body.lineHeight};

  color: ${props => props.theme.color.brand.primary};
  opacity: 0.87;
`;

export const Link = styled.a`
  text-decoration: none;
  color: ${props => props.theme.color.brand.grey};

  > .icon {
    position: relative;
    top: 2px;

    margin: 0 ${props => props.theme.layout.gutter / 2}px;
  }
`;
